import { render } from "./MultiStepFormHeaderIcon.vue?vue&type=template&id=127c3c8c&ts=true"
import script from "./MultiStepFormHeaderIcon.vue?vue&type=script&lang=ts"
export * from "./MultiStepFormHeaderIcon.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__